(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.state = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.score = 0;
        this.newCellPositions = [];
        this.loseMessage = document.querySelector(".container .message-container .message-lose");
        this.startMessage = document.querySelector(".container .message-container .message-start");
        this.winMessage = document.querySelector(".container .message-container .message-win");
        if (initialState) this.state = initialState;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft(mode) {
                var changes = false;
                for(var indexOfRow = 0; indexOfRow < this.state.length; indexOfRow++){
                    var res = this.sortRow(this.state[indexOfRow], mode);
                    changes = changes ? true : res[1];
                    if (mode === 1) this.state[indexOfRow] = (0, $227c6742e0ff6f82$export$71511d61b312f219)(res[0]);
                }
                if (changes && mode === 1) {
                    this.getFreeCellwithRandomValue();
                    this.changeCell();
                }
                if (mode === 1) this.updateInfo();
                return changes;
            }
        },
        {
            key: "moveRight",
            value: function moveRight(mode) {
                var changes = false;
                for(var indexOfRow = 0; indexOfRow < this.state.length; indexOfRow++){
                    var res = this.sortRow((0, $227c6742e0ff6f82$export$71511d61b312f219)(this.state[indexOfRow]).reverse(), mode);
                    if (mode === 1) this.state[indexOfRow] = (0, $227c6742e0ff6f82$export$71511d61b312f219)(res[0].reverse());
                    changes = changes ? true : res[1];
                }
                if (changes && mode === 1) {
                    this.getFreeCellwithRandomValue();
                    this.changeCell();
                }
                if (mode === 1) this.updateInfo();
                return changes;
            }
        },
        {
            key: "moveUp",
            value: function moveUp(mode) {
                var _this = this, _loop = function(indexOfElem) {
                    var arrToSort = [];
                    for(var indexOfRow = 0; indexOfRow < _this.state.length; indexOfRow++)arrToSort.push(_this.state[indexOfRow][indexOfElem]);
                    var res = _this.sortRow(arrToSort, mode);
                    changes = changes ? true : res[1];
                    if (changes && mode === 1) res[0].forEach(function(num, indexOfRow) {
                        _this1.state[indexOfRow][indexOfElem] = num;
                    });
                };
                var _this1 = this;
                var changes = false;
                for(var indexOfElem = 0; indexOfElem < this.state.length; indexOfElem++)_loop(indexOfElem);
                if (changes && mode === 1) {
                    this.getFreeCellwithRandomValue();
                    this.changeCell();
                }
                if (mode === 1) this.updateInfo();
                return changes;
            }
        },
        {
            key: "moveDown",
            value: function moveDown(mode) {
                var _this = this, _loop = function(indexOfElem) {
                    var arrToSort = [];
                    for(var indexOfRow = 0; indexOfRow < _this.state.length; indexOfRow++)arrToSort.unshift(_this.state[indexOfRow][indexOfElem]);
                    res = _this.sortRow(arrToSort, mode);
                    changes = changes ? true : res[1];
                    if (mode === 1) res[0].reverse().forEach(function(num, indexOfRow) {
                        _this1.state[indexOfRow][indexOfElem] = num;
                    });
                };
                var _this1 = this;
                var changes = false;
                var res;
                for(var indexOfElem = 0; indexOfElem < this.state.length; indexOfElem++)_loop(indexOfElem);
                if (changes && mode === 1) {
                    this.getFreeCellwithRandomValue();
                    this.changeCell();
                }
                if (mode === 1) this.updateInfo();
                return changes;
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                var gameScore = document.querySelector(".controls p.info .game-score");
                gameScore.textContent = this.score;
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                if (this.state.some(function(row) {
                    if (row.some(function(num) {
                        if (num === 2048) return true;
                        return false;
                    })) return true;
                    return false;
                })) return "win";
                else if (this.state.every(function(row) {
                    if (row.every(function(num) {
                        return num === 0;
                    })) return true;
                    return false;
                })) return "idle";
                else {
                    var results = [
                        this.moveLeft(0),
                        this.moveRight(0),
                        this.moveUp(0),
                        this.moveDown(0)
                    ];
                    if (results.some(function(res) {
                        if (res === true) return true;
                        return false;
                    })) return "playing";
                    return "lose";
                }
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.startMessage.classList.add("hidden");
                var button = document.querySelector(".controls .button");
                if (button.classList.contains("start")) button.classList.remove("start");
                button.classList.add("restart");
                button.textContent = "Restart";
                var firstValue = this.getFreeCellwithRandomValue();
                if (firstValue === 2) this.getFreeCellwithRandomValue();
                else this.getFreeCellwithRandomValue(2);
                this.changeCell();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.startMessage.classList.remove("hidden");
                if (!this.loseMessage.classList.contains("hidden")) this.loseMessage.classList.add("hidden");
                if (!this.winMessage.classList.contains("hidden")) this.winMessage.classList.add("hidden");
                var button = document.querySelector(".controls .button");
                if (button.classList.contains("restart")) button.classList.remove("restart");
                button.classList.add("start");
                button.textContent = "Start";
                this.state = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.score = 0;
                this.getScore();
                this.changeCell();
            }
        },
        {
            // Add your own methods here
            key: "getFreeCellwithRandomValue",
            value: function getFreeCellwithRandomValue(value) {
                var freeCells = [];
                var randomValue;
                if (value) randomValue = value;
                else randomValue = Math.random() > 0.1 ? 2 : 4;
                for(var idxOfRow = 0; idxOfRow < this.state.length; idxOfRow++){
                    var row = this.state[idxOfRow];
                    for(var idxOfCell = 0; idxOfCell < row.length; idxOfCell++)if (row[idxOfCell] === 0) freeCells.push([
                        idxOfRow,
                        idxOfCell
                    ]);
                }
                var randomIndex = Math.round(Math.random() * (freeCells.length - 1));
                var randomElem = freeCells[randomIndex];
                this.state[randomElem[0]][randomElem[1]] = randomValue;
                this.newCellPositions.push([
                    randomElem[0],
                    randomElem[1]
                ]);
                return randomValue;
            }
        },
        {
            key: "changeCell",
            value: function changeCell() {
                var _this = this, _loop = function(indexOfRow) {
                    var _this1 = _this, _loop = function(indexOfElem) {
                        var td = tr.children[indexOfElem];
                        var value = _this1.state[indexOfRow][indexOfElem];
                        var regExp = /field-cell--(\d+)/;
                        var oldValue = 0;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = (0, $227c6742e0ff6f82$export$71511d61b312f219)(td.classList)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var cls = _step.value;
                                var match = cls.match(regExp);
                                if (match) {
                                    oldValue = parseInt(match[1]);
                                    td.classList.remove(cls);
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (value === 0) {
                            td.textContent = "";
                            td.setAttribute("class", "field-cell");
                        } else {
                            td.textContent = value;
                            td.classList.remove("tile-appear", "tile-merge");
                            td.classList.add("field-cell--".concat(value));
                            var isNew = _this1.newCellPositions.some(function(param) {
                                var _param = (0, $efec029548ccee7f$export$71511d61b312f219)(param, 2), r = _param[0], c = _param[1];
                                return r === indexOfRow && c === indexOfElem;
                            });
                            var isMerge = oldValue !== 0 && value === oldValue * 2;
                            if (isNew) td.classList.add("tile-appear");
                            else if (isMerge) td.classList.add("tile-merge");
                        }
                    };
                    var tr = document.querySelectorAll("tbody .field-row")[indexOfRow];
                    for(var indexOfElem = 0; tr.children.length > indexOfElem; indexOfElem++)_loop(indexOfElem);
                };
                for(var indexOfRow = 0; indexOfRow < this.state.length; indexOfRow++)_loop(indexOfRow);
                this.newCellPositions = [];
            }
        },
        {
            key: "sortRow",
            value: function sortRow(row, mode) {
                var changes = false;
                if (row.every(function(num) {
                    if (num === 0) return true;
                    return false;
                })) return [
                    row,
                    changes
                ];
                var arr = row.filter(function(num) {
                    if (num === 0) return false;
                    return true;
                });
                for(var indexOfElem = 0; indexOfElem < arr.length - 1; indexOfElem++){
                    var firstNum = arr[indexOfElem];
                    var secondNum = arr[indexOfElem + 1];
                    if (firstNum === secondNum && firstNum !== 0) {
                        arr[indexOfElem] = firstNum + secondNum;
                        arr[indexOfElem + 1] = 0;
                        if (mode) this.score += firstNum + secondNum;
                        changes = true;
                    } else if (firstNum === 0 && secondNum !== 0) {
                        arr[indexOfElem] = secondNum;
                        arr[indexOfElem + 1] = 0;
                        changes = true;
                    }
                }
                while(arr.length < 4)arr.push(0);
                for(var indexOfElem1 = 0; indexOfElem1 < arr.length; indexOfElem1++)if (row[indexOfElem1] !== arr[indexOfElem1]) changes = true;
                return [
                    arr,
                    changes
                ];
            }
        },
        {
            key: "updateInfo",
            value: function updateInfo() {
                var sts = this.getStatus();
                this.getScore();
                if (sts === "lose") this.loseMessage.classList.remove("hidden");
                else if (sts === "win") this.winMessage.classList.remove("hidden");
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
// Write your code here
var $197cd56b15c33885$var$button = document.querySelector(".controls .button");
$197cd56b15c33885$var$button.addEventListener("click", function(e) {
    if ($197cd56b15c33885$var$button.classList.contains("start")) $197cd56b15c33885$var$game.start();
    else if ($197cd56b15c33885$var$button.classList.contains("restart")) $197cd56b15c33885$var$game.restart();
});
document.addEventListener("keydown", function(e) {
    if (/Arrow/.test(e.key) && $197cd56b15c33885$var$game.getStatus() === "idle") {
        $197cd56b15c33885$var$game.start();
        return;
    }
    switch(e.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft(1);
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight(1);
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp(1);
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown(1);
            break;
    }
});

})();
//# sourceMappingURL=index.58e8b44d.js.map
